import React, { useRef, useState } from "react";
import "./Popular.css";
import TextFade from "../../components/CustomTexts/TextFade";
import TextEffect from "../../components/CustomTexts/TextEffect";

type Slide = {
  img: string;
  category: string;
  heading: string;
};

const slides: Slide[] = [
  {
    img: "https://ywrjsnozmpnsvsmxfkiv.supabase.co/storage/v1/object/public/training-images//FB_IMG_1741643949807.jpg",
    category: "Farm",
    heading: "Raising Potatoes in the Region",
  },
  {
    img: "https://ywrjsnozmpnsvsmxfkiv.supabase.co/storage/v1/object/public/training-images//IMG_0017.JPG",
    category: "Shabu Training 2021",
    heading: "Empowering Farmers with Shabu Training",
  },
  {
    img: "https://ywrjsnozmpnsvsmxfkiv.supabase.co/storage/v1/object/public/training-images//7.jpg",
    category: "Vine cutting",
    heading: "Vine cutting and planting Pratices",
  },
  {
    img: "https://ywrjsnozmpnsvsmxfkiv.supabase.co/storage/v1/object/public/training-images//FB_IMG_1741643739793.jpg",
    category: "Ohaji Farm",
    heading: "Ohaji Farm right after planting",
  },
  {
    img: "https://ywrjsnozmpnsvsmxfkiv.supabase.co/storage/v1/object/public/training-images//flesh.jpg",
    category: "Chyspon Foods",
    heading: "Chyson Foods - Freshly Processed",
  },
  {
    img: "https://ywrjsnozmpnsvsmxfkiv.supabase.co/storage/v1/object/public/training-images//Irrigation%20System%20-%206.jpg",
    category: "Irrigation System",
    heading: "Irrigation System in Action",
  },
];

const PopularTile: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.pageX - (trackRef.current?.offsetLeft || 0));
    setScrollLeft(trackRef.current?.scrollLeft || 0);
    if (trackRef.current) {
      trackRef.current.style.animationPlayState = "paused";
    }
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    if (trackRef.current) {
      trackRef.current.style.animationPlayState = "running";
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    if (trackRef.current) {
      trackRef.current.style.animationPlayState = "running";
    }
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !trackRef.current) return;
    e.preventDefault();
    const x = e.pageX - trackRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    trackRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div>
      <div className="overflow-x-hidden py-20 bg-white">
        <div className="flex w-full px-[5%] flex-col items-center justify-center">
          <TextFade animation="fade-down">
            <h1 className="md:text-[70px] text-[35px] font-bold text-dark leading-tight">
              <TextEffect text2="Our Gallery " />
            </h1>
          </TextFade>
          <br/>
          <p className="text-dark md:text-[20px] text-[14px] text-center md:w-[65%] w-full">
            <TextFade animation="fade-down">
              See how we've brought the tasks of our clients to life across a
              range of Agriculture projects.
            </TextFade>
          </p>
        </div>
      </div>

      <section className="hero-section">
        <div className="slider-container">
          <div
            className="slider-track"
            ref={trackRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
          >
            {[...slides, ...slides].map((slide, index) => (
              <a className="cardPopular" href="/services/gallery" key={index}>
                <div
                  className="cardPopular__background"
                  style={{ backgroundImage: `url(${slide.img})` }}
                />
                <div className="cardPopular__content">
                  <p className="cardPopular__category">{slide.category}</p>
                  <h3 className="cardPopular__heading">{slide.heading}</h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PopularTile;
